import { Box, Button, Tooltip } from "@material-ui/core";
import { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import { Loading } from "../../components/shared/loading";
import { UserContext } from "../../contexts/UserContext";
import { Helmet } from "react-helmet";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "bootstrap/dist/css/bootstrap.min.css";

import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import AddIcon from "@material-ui/icons/Add";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@material-ui/icons/VisibilityOffOutlined";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import RemoveCircleOutlineIcon from "@material-ui/icons/RemoveCircleOutline";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";
const $ = require("jquery");

export const AllProducts = () => {
  const navigate = useNavigate();
  const classes = useAdminStyles();
  const toast = useToast();
  const { setUser } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    Axios.get("/api/admin/products", { headers: { headKey } }).then((res) => {
      if (res.status === 200 && res.data.status) {
        setData(res.data.data);
        setLoading(false);
        $(document).ready(function () {
          $("#products_table").DataTable({ destroy: true });
        });
      } else {
        setUser(null);
        navigate("/");
      }
    });
  };

  const toggleStatus = (id, visible) => {
    const fd = new FormData();
    fd.append("id", id);
    Axios.post("/api/admin/product_status", fd, { headers: { headKey } }).then(
      (res) => {
        if (res.status === 200) {
          toast.success(visible === 1 ? "Product hidden" : "Product shown");
          getData();
        } else {
          toast.error("Failed to update status");
        }
      }
    );
  };

  if (loading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>All Products - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="Manage"
        title="Products"
        subtitle="Edit product content, meta, ordering and visibility on the products page."
        actions={
          <Button
            component={Link}
            to="/dash/addproduct"
            className={classes.primaryBtn}
            startIcon={<AddIcon />}
          >
            Add Product
          </Button>
        }
      />

      <Box className={classes.tableWrap}>
        <table id="products_table" className="display" style={{ width: "100%" }}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Slug</th>
              <th>Type</th>
              <th>Category</th>
              <th>Priority</th>
              <th>Visible</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((da) => (
                <tr key={da.id}>
                  <td>{da.id}</td>
                  <td style={{ fontWeight: 600, color: "#1a1a1a" }}>
                    {da.name}
                  </td>
                  <td>{da.slug}</td>
                  <td>
                    <span
                      style={{
                        textTransform: "uppercase",
                        fontSize: "0.68rem",
                        fontWeight: 700,
                        color: "#9b3b9b",
                      }}
                    >
                      {da.status}
                    </span>
                  </td>
                  <td>{da.category}</td>
                  <td>{da.priority}</td>
                  <td>
                    {da.visible === 1 ? (
                      <span
                        className={`${classes.badge} ${classes.badgeActive}`}
                      >
                        <CheckCircleOutlineIcon /> Visible
                      </span>
                    ) : (
                      <span
                        className={`${classes.badge} ${classes.badgeInactive}`}
                      >
                        <RemoveCircleOutlineIcon /> Hidden
                      </span>
                    )}
                  </td>
                  <td>
                    <Box className={classes.actionCell}>
                      <Tooltip title="Edit" arrow>
                        <Link
                          to={"/dash/editproduct/" + da.id}
                          className={classes.iconBtn}
                          aria-label="Edit"
                        >
                          <EditOutlinedIcon />
                        </Link>
                      </Tooltip>
                      <Tooltip
                        title={da.visible === 1 ? "Hide" : "Show"}
                        arrow
                      >
                        <button
                          type="button"
                          className={classes.iconBtn}
                          onClick={() => toggleStatus(da.id, da.visible)}
                          aria-label={da.visible === 1 ? "Hide" : "Show"}
                        >
                          {da.visible === 1 ? (
                            <VisibilityOffOutlinedIcon />
                          ) : (
                            <VisibilityOutlinedIcon />
                          )}
                        </button>
                      </Tooltip>
                    </Box>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </Box>
    </div>
  );
};
